<template>
	<NP-Modal :toggle="toggle">
		<div class="wrap">
			<img :src="modalError" />
			<h3>Аварійне закриття зміни</h3>
			<span v-if="!pendingCashToCourier">
				Ви впевнені, що хочете закрити зміну касира
				<span class="bold">{{ cashdesk.user }}</span>
				{{ noBalance ? '?' : 'та створити ПКО на суму:' }}
			</span>
			<div v-if="!noBalance" class="input">
				<span class="amount"><span class="uah" />{{ cashdesk.balance | formatMoney }}</span>
			</div>
			<div v-if="pendingCashToCourier" class="pending-courier-cash">
				<span></span>
				<div class="pending-courier-text">
					<span class="text-bold"> Спочатку оформи ПКО з типом «Переміщення розмін» за: </span>
					<span class="text" :key="order.id" v-for="(order, i) in pendingCashToCourierOrdersList">
						{{ `${++i}. ` + order }}
					</span>
				</div>
			</div>
		</div>
		<div class="buttons">
			<NP-Button priority="low-borderless" @click="toggle">
				<div slot="icon" class="icon-close" />
				Скасувати
			</NP-Button>
			<NP-Button v-if="pendingCashToCourier" type="submit" priority="high" @click.stop="handleCreateOrder">
				Cтворити Ордер
			</NP-Button>
			<NP-Button
				v-else
				type="submit"
				priority="high"
				@click.stop="() => confirm({ loadingAction: true })"
				:loading="loadingActions.includes('confirmShiftClosal')"
			>
				Підтвердити
			</NP-Button>
		</div>
	</NP-Modal>
</template>

<script>
import modalError from '@assets/images/modal-error.svg';
import BigNumber from 'bignumber.js';
import { enum as subTypes } from '@repo/enums/cashbook-order-sub-types';

export default {
	name: 'CashdeskClosalModal',
	props: {
		toggle: { type: Function, default: null },
		cashdesk: { type: Object, default: null },
		confirm: { type: Function, default: null },
		createOrder: { type: Function, default: null },
		loadingActions: { type: Array, default: () => [] },
		pendingOrders: { type: Array, default: () => [] }
	},
	data() {
		return {
			modalError
		};
	},
	computed: {
		noBalance() {
			return new BigNumber(this.cashdesk.balance).isEqualTo(0);
		},
		pendingCashToCourier() {
			return !!this.cashdesk.cashToCourier && !!this.cashdesk?.pending_courier_balance;
		},
		pendingCashToCourierOrdersList() {
			if (this.pendingCashToCourier) {
				let ordersList = this.pendingOrders
					.filter((o) => o.participant_id === this.cashdesk.user_id && o.sub_type === subTypes.cashToCourier)
					.map((o) => {
						return `ВКО №${o.id} від ПНФП ${o.salepoint_code} через ${this.orderFullName(o)}; ${o.factual_amount} грн`;
					});
				return ordersList;
			}
			return null;
		}
	},
	methods: {
		handleCreateOrder() {
			this.toggle();
			this.createOrder(this.cashdesk);
		},
		orderFullName(o) {
			return [
				o.participant_last_name,
				` ${o?.participant_first_name[0].toUpperCase()}.`,
				`${o?.participant_patronymic[0].toUpperCase()}`
			].join('');
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/variables';
@import '@assets/scss/mixins';

$icon-close: '~@assets/images/icon-close.svg';

::v-deep .modal-container {
	width: 413px;
	border-top: 2px solid $red !important;
	.modal-body {
		padding: 0 !important;
	}
}

.pending-courier {
	&-text {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		.text,
		.text-bold {
			text-align: left !important;
			color: $red;
		}
		.text {
			padding-left: 5px;
			&:not(:last-child) {
				margin-bottom: 15px;
			}
		}
		.text-bold {
			font-weight: 700;
		}
	}
	&-cash {
		padding: 10px 12px 0px 12px;
		background-color: $dark-pink;
		border-radius: 4px;
		margin-top: 16px;
	}
}
.wrap {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0 38px;
	span,
	h3 {
		text-align: center;
		margin-bottom: 15px;
	}
	h3 {
		color: $red;
	}
	span {
		font-size: 14px;
	}
	.input {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 215px;
		height: 40px;
		border-radius: $border-radius;
		background: $gray-10;
		.amount {
			.uah {
				margin-right: 6px;
			}
			margin-top: 15px;
			font-size: 14px;
			font-family: Proxima Nova Semibold;
		}
	}
}
.buttons {
	display: flex;
	justify-content: space-between;
	padding: 24px;
	.icon-close {
		@include make-icon($icon-close, $gray-40, 20px, 20px);
	}
}
</style>
